import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "glores-B-join-complete" }
const _hoisted_5 = { class: "glores-B-join-msg" }
const _hoisted_6 = { class: "glores-B-msg-text1" }
const _hoisted_7 = { class: "msg-id" }
const _hoisted_8 = { class: "glores-B-btn-wrap glores-B-m-half" }
const _hoisted_9 = { class: "btn-cell" }
const _hoisted_10 = { class: "btn-cell" }

import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRoute } from "vue-router";
import { ref, onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'JoinSuccess',
  setup(__props) {

const route = useRoute();
const registeredId = ref<string>("");

onMounted(() => {
  const idParam = route.params.id;
  if (typeof idParam === "string") {
    registeredId.value = idParam;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "",
      subtitle: "",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("회원가입"),
          _createElementVNode("span")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "glores-B-join-step" }, [
            _createElementVNode("ol", null, [
              _createElementVNode("li", null, [
                _createElementVNode("span", null, "01 약관동의")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", null, "02 정보입력")
              ]),
              _createElementVNode("li", { class: "on" }, [
                _createElementVNode("span", null, "03 가입완료")
              ])
            ])
          ], -1)),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "glores-B-join-title" }, [
            _createElementVNode("h3", { class: "join-title" }, "가입완료")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("span", null, "반갑습니다.", -1)),
              _createElementVNode("strong", _hoisted_7, "\"" + _toDisplayString(registeredId.value) + "\"", 1),
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "고객님!", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "회원 가입이 완료 되었습니다.", -1))
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "glores-B-msg-text2" }, [
              _createElementVNode("span", null, "회원님은 저희 사이트에서 제공하는 모든 서비스와 이벤트를 편리하게 이용하실 수 있습니다."),
              _createElementVNode("br"),
              _createTextVNode(" 'COKOLab. Inc.'는 최고의 사이트가 되기 위해 최선의 노력을 다하겠습니다. "),
              _createElementVNode("span", { class: "glores-B-text-thx" }, "감사합니다.")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_router_link, {
                to: `${_unref(USER_ROUTES).Home.Path}`,
                class: "glores-B-btn-type1 glores-B-large glores-B-m-full-width"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("메인화면")
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: `${_unref(USER_ROUTES).Login.Path}`,
                class: "glores-B-btn-type1 glores-B-large glores-B-m-full-width glores-B-highlight"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("로그인")
                ])),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})